<template>
  <div class="page-content" :class="[showImage ? 'show-image' : '']">
    <ShowImageArrow v-if="!noArrow" @click="showImage = !showImage; $emit('toggleImage', showImage)"/>
    <slot name="page"></slot>
  </div>
</template>

<script>
import ShowImageArrow from "@/patterns/ShowImageArrow.vue";
export default {
  name: "PageBottom",
  components: {ShowImageArrow},  
  data: () => ({
      showImage:true,
  }),
  props : {
      noArrow: {
          type:Boolean,
          default:false
      }
  },
  mounted() {
      setTimeout(() => this.showImage = false, this.$store.state.delay);
  },
  beforeDestroy: function () {},
  methods: {},
  computed: {},  
};
</script>


<style lang="scss" scoped>
.toggle-image {    
    left:50%;
    bottom:calc(60% - 15px);    
}
.page-content {
    width:100%;
    height:100%;
    margin:0;
    padding:0;
    transition: transform 0.5s; 
    position: relative;    
    flex-grow: 0;
    background-color:rgba(#0B0B0B, 0.9);    
    &.content:after {
      content:" ";
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      
      background-image:url('~@/assets/shapes/side-graphic.svg');
      background-size: contain;
      background-position: top left;
      background-repeat: no-repeat;
      opacity: 0.05;
      pointer-events: none;
    }   
}
.all-content {
    display:flex;    
    height:100vh;
    width:100%;  
    justify-content: flex-start;
    background: linear-gradient(135deg, #232323 0%, #0C0C0C 100%);    
}
.image {
    width:100%;
    height:calc(100% - 50px);      
    flex-shrink: 0;
    flex-grow: 1;
    position:absolute;
    left:0;
    top:0;
    transition: width 0.5s;   
}
.text-content {
    position:relative;    
    height:100%;
    overflow: auto;
    margin-bottom: 50px;
    padding-right:50px;
    scroll-behavior: smooth;     
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: #2E2E30;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #B2B3B8;
    }
}
.content {
    flex-grow: 0;
    flex-shrink: 0;
    height:60%;
    display:flex;
    flex-direction: column;
    padding:50px;
    box-sizing: border-box;
    position: relative;
    top:40%;
    &:after {
      content:" ";
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      background-image:url('~@/assets/shapes/side-graphic.svg');
      background-size: contain;
      background-position: top left;
      background-repeat: no-repeat;
      opacity: 0.05;
      pointer-events: none;
    }  
}
.image img {
    position: absolute;
    left:0;
    top:0;    
    height:100%;
    width:100%;
    object-fit: cover;
    object-position: top;
}
.show-image {
    overflow: hidden;
    .toggle-image {
        bottom: 75px;
    }
    .page-content {
        transform:translateY(calc(100% - 90px));
    }
}
</style>
